import React, { useState, useRef } from 'react'
import { Validaciones } from '@renedelangel/helpers';

// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';

// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';

// material-ui icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';

import { getEncuestaCatOpcion, tablaEncuestaCatOpciones } from '../../../querys/EncuestaCatalogo';
import { upsertEncuestaCatOpcion, deleteEncuestaCatOpcion } from '../../../mutations/EncuestaCatalogo';

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger, success, primary } from '../../../_layout/helpers/colores';

import * as Permisos from '../Permisos';

const { trim } = Validaciones;

const TiposDato = [
    { value: "TEXTO", label: "Texto" },
    { value: "TEXTO_LARGO", label: "Texto largo" },
    { value: "NUMERO", label: "Número" },
    { value: "SUMA", label: "Suma de la fila (calculada)" }
];

// Una pregunta TABLA lleva columnas, y filas cuando son fijas; una pregunta OPCIONES lleva opciones
function tiposOpcionDe({ tipo, modoFilas }) {
    if (tipo === "OPCIONES") return [{ value: "OPCION", label: "Opción" }];
    let tipos = [{ value: "COLUMNA", label: "Columna" }];
    if (modoFilas === "FIJAS") tipos.push({ value: "FILA", label: "Fila" });
    return tipos;
}

function Opciones({ pregunta, accionesUsr }) {

    const { token } = useSelector(state => state.login);
    const { preguntaCatID, tipo, modoFilas, texto } = pregunta;
    const tiposOpcion = tiposOpcionDe({ tipo, modoFilas });

    const cleanState = {
        opcionCatID: null,
        preguntaCatID,
        tipoOpcion: tiposOpcion[0].value,
        etiqueta: "",
        tipoDato: "NUMERO",
        muestraDetalle: false,
        etiquetaEditable: false,
        orden: ""
    };
    const cleanErrorState = {
        tipoOpcion: { error: false, helperText: "" },
        etiqueta: { error: false, helperText: "" },
        tipoDato: { error: false, helperText: "" }
    }

    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [state, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);

    const nombreTipos = tipo === "OPCIONES" ? "Opciones" : (modoFilas === "FIJAS" ? "Columnas y Filas" : "Columnas");
    let titleAccion = state.opcionCatID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} ${tiposOpcion.find(t => t.value === state.tipoOpcion).label}`;

    const tipoOpcionRef = useRef(null);
    const etiquetaRef = useRef(null);
    const tipoDatoRef = useRef(null);

    let acciones = [{
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "opcionCatID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState, setOpen, setAlert,
            asyncGet: getEncuestaCatOpcion,
            formatearResultado: [
                { id: "muestraDetalle", formato: (data) => Number(data) === 1 },
                { id: "etiquetaEditable", formato: (data) => Number(data) === 1 },
                { id: "tipoDato", formato: (data) => data || "NUMERO" }
            ]
        })
    }, {
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "opcionCatID" }, { campo: "etiqueta" }],
        disabled: { multiseleccion: true },
        onClick: ({ opcionCatID, etiqueta }) => handelAlertEliminar({
            setAlert,
            mensaje: ` "${etiqueta}"`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar, actualizar,
                parametros: { opcionCatID }, asyncDelete: deleteEncuestaCatOpcion
            })
        })
    }];

    let botones = [
        {
            accionID: [2],
            icono: Add,
            color: success,
            descripcion: "Agregar",
            onClick: () => setOpen(true),
            disabled: { multiseleccion: true }
        }, {
            icono: SyncIcon,
            color: info,
            descripcion: "Actualizar",
            onClick: () => setActualizar(!actualizar),
            disabled: { multiseleccion: true }
        }];

    const infoTabla = {
        botones,
        acciones,
        loader,
        actualizar,
        id: "opcionCatID",
        color: primary,
        title: nombreTipos,
        title2: texto || (tipo === "TABLA" ? "Tabla" : ""),
        iconTable: <ViewColumnIcon />,
        headers: [
            { variable: "opcionCatID", descripcion: "opcionCatID", hide: true },
            { variable: "tipoOpcionNombre", descripcion: "Tipo" },
            { variable: "orden", descripcion: "Orden" },
            { variable: "etiqueta", descripcion: "Etiqueta" },
            { variable: "tipoDatoNombre", descripcion: "Tipo de dato", hide: tipo !== "TABLA" },
            { variable: "preguntaCatID", descripcion: "preguntaCatID", hide: true },
            { variable: "tipoOpcion", descripcion: "tipoOpcion", hide: true },
            { variable: "tipoDato", descripcion: "tipoDato", hide: true },
            { variable: "muestraDetalle", descripcion: "muestraDetalle", hide: true },
            { variable: "etiquetaEditable", descripcion: "etiquetaEditable", hide: true },
            { variable: "fechaModificacion", descripcion: "fechaModificacion", hide: true }
        ],
        responsiveTitle: ["etiqueta"],
        filter: [
            { campo: "etiqueta" }
        ],
        alineacion: [{ columnas: [0, 1, 2, 4], alineacion: "center" }, { columnas: [3], alineacion: "left" }]
    }

    const inputs = [
        {
            id: "Arriba",
            tipo: "fieldset",
            grid: { lg: 12 },
            inputs: [
                tiposOpcion.length > 1 && {
                    disabled,
                    id: "tipoOpcion",
                    value: state.tipoOpcion,
                    error: errorState.tipoOpcion.error,
                    helperText: errorState.tipoOpcion.helperText,
                    inputRef: tipoOpcionRef,
                    tipo: "select",
                    data: tiposOpcion,
                    title: "Tipo *",
                    grid: { md: 4, lg: 4 },
                    onChange: ({ target: { value } }) => handleChange(value, "tipoOpcion")
                },
                {
                    disabled,
                    id: "etiqueta",
                    value: state.etiqueta,
                    error: errorState.etiqueta.error,
                    success: state.etiqueta && !errorState.etiqueta.error ? true : undefined,
                    helperText: errorState.etiqueta.helperText,
                    inputRef: etiquetaRef,
                    title: state.tipoOpcion === "COLUMNA" ? "Encabezado *" : "Etiqueta *",
                    placeholder: state.tipoOpcion === "COLUMNA" ? "P. ej. Tonelaje Anual" : (state.tipoOpcion === "FILA" ? "P. ej. Graneles" : "P. ej. RENTADO"),
                    grid: { md: tiposOpcion.length > 1 ? 8 : 12, lg: tiposOpcion.length > 1 ? 8 : 12 },
                    onChange: ({ target: { value } }) => handleChange(value, "etiqueta"),
                    onKeyDown: () => { return; }
                },
                state.tipoOpcion === "COLUMNA" && {
                    disabled,
                    id: "tipoDato",
                    value: state.tipoDato,
                    error: errorState.tipoDato.error,
                    helperText: errorState.tipoDato.helperText || (state.tipoDato === "SUMA" ? "Suma las columnas numéricas de la misma fila" : ""),
                    inputRef: tipoDatoRef,
                    tipo: "select",
                    data: TiposDato,
                    title: "Tipo de dato *",
                    grid: { md: 4, lg: 4 },
                    onChange: ({ target: { value } }) => handleChange(value, "tipoDato")
                },
                state.tipoOpcion === "OPCION" && {
                    disabled,
                    id: "muestraDetalle",
                    value: state.muestraDetalle,
                    checked: state.muestraDetalle,
                    title: "Pide explicación al marcarla",
                    tipo: "switch",
                    grid: { md: 4, lg: 4 },
                    onChange: (e) => handleChange(e.target.checked, "muestraDetalle")
                },
                state.tipoOpcion === "FILA" && {
                    disabled,
                    id: "etiquetaEditable",
                    value: state.etiquetaEditable,
                    checked: state.etiquetaEditable,
                    title: "Quien contesta puede especificarla (p. ej. Otros)",
                    tipo: "switch",
                    grid: { md: 4, lg: 4 },
                    onChange: (e) => handleChange(e.target.checked, "etiquetaEditable")
                },
                {
                    disabled,
                    id: "orden",
                    value: state.orden,
                    helperText: "Vacío para agregarla al final",
                    title: "Orden",
                    grid: { md: 4, lg: 4 },
                    onChange: ({ target: { value } }) => handleChange(value.replace(/[^0-9]/g, ""), "orden"),
                    onKeyDown: () => { return; }
                }
            ].filter(Boolean)
        }
    ];

    let accionesFormulario = [{
        accionID: state.opcionCatID ? [3] : [2],
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: etiquetaRef,
            mensajeCorrecto: `Se ${state.opcionCatID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar,
        }),
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleValidaciones({ tipoOpcion, etiqueta, tipoDato }) {

        let error;
        let validaciones = [
            {
                condicion: !tipoOpcion,
                ref: tipoOpcionRef, keyError: "tipoOpcion",
                mensajeError: "Debe seleccionar el tipo"
            },
            {
                condicion: !etiqueta || trim(etiqueta) === "",
                ref: etiquetaRef, keyError: "etiqueta",
                mensajeError: "Debe especificar la etiqueta"
            },
            {
                condicion: tipoOpcion === "COLUMNA" && !tipoDato,
                ref: tipoDatoRef, keyError: "tipoDato",
                mensajeError: "Debe seleccionar el tipo de dato de la columna"
            }
        ];
        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;

    }

    function ftGuardar() {
        async function ftGuardar() {

            let { opcionCatID, tipoOpcion, etiqueta, tipoDato, muestraDetalle, etiquetaEditable, orden } = state;

            let error = await handleValidaciones({ tipoOpcion, etiqueta, tipoDato });

            if (error) return error;

            // El servidor descarta los datos que no aplican al tipo de opción
            await upsertEncuestaCatOpcion({
                input: {
                    opcionCatID: opcionCatID || null,
                    preguntaCatID,
                    tipoOpcion,
                    etiqueta: trim(etiqueta),
                    tipoDato: tipoOpcion === "COLUMNA" ? tipoDato : null,
                    muestraDetalle: muestraDetalle ? 1 : 0,
                    etiquetaEditable: etiquetaEditable ? 1 : 0,
                    orden: orden !== "" ? Number(orden) : null
                }
            }, token);

        }
        return ftGuardar();
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key) { setState({ ...state, [key]: value }); }

    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
        accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    }

    return (<>
        <Tabla
            infoTabla={infoTabla}
            asyncData={tablaEncuestaCatOpciones}
            token={token}
            parametrosFijos={{ preguntaCatID }}
        />
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            maxWidth={false}
            acciones={accionesFormulario}
            focus={etiquetaRef}
        />
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);

}

export default Opciones;
